export default {
  'Start at': 'Beginnen mit',
  'Set to current time': 'Auf aktuelle Zeit einstellen',
  'Audio volume': 'Audio Lautstärke',
  'Video volume': 'Video Lautstärke',
  'Trim audio': 'Audio zuschneiden',
  'Audio will end with the video': 'Audio endet mit dem Video.',
  'Trim': 'Trimmen',
}